<template>
  <div class="pc-main">
    <mainPage></mainPage>
  </div>
</template>

<script>
import mainPage from "./subView/mainPage.vue"

export default {
  name: "app",
  components: { mainPage }
};
</script>


<style lang="less">
@import "~src/styles/Normalize";
@import "~src/styles/index";

body {
  background-color: #1c1b20;
}

@media screen and (min-width: @width) {
  .pc-main {
    width: 100vw;
    margin: 0 auto;
  }
}

@media screen and (max-width: @width) {
  .pc-main {
    width: 100vw;
    margin: 0 auto;
  }
}
</style>
